import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { SingleValue } from "react-select";

// import Table from "../../../core/common/dataTable";
// import { TableData } from "../../../core/data/interface";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { all_routes } from "../../router/all_routes";
// import TooltipOption from "../../../core/common/tooltipOption";
import useQuery, { _get, _post } from "../../Utils/Helper";
// import { ClassAttendanceForm as initialClassAttendanceForm } from "../../../core/data/json/student_attendance";
// import { academicYear } from "../../../core/common/selectoption/selectoption";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { SingleValue } from "react-select";
import { Button, Table } from "antd";
import useSelection from "antd/es/table/hooks/useSelection";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { filter } from "../../../style/icon/fontawesome/js/v4-shims";

// Define interfaces for better type safety
interface Class {
  id: number;
  class_name: string;
  class_code: string;
}

interface Section {
  id: number;
  section: string;
}

interface Student {
  id: number;
  admission_no: string;
  student_name: string;
  attendance: AttendanceStatus;
  notes?: string;
  school_id?: string;
}

interface Classes {
  id: number;
  teacher_id: string;
  section: string;
  subject: AttendanceStatus;
  class_name: string;
  role: string;
}

type AttendanceStatus = "Present" | "Late" | "Absent" | "Holiday" | "Halfday" | "";

const ClassAttendanceForm: React.FC = () => {
  const q = useQuery()
  const class_name = q.get("class_name")??""
  const class_code = q.get("class_code")??""
  const initialForm = {
    query_type: "",
    teacher_name: "",
    teacher_id: "",
    section: "",
    class_name,
    class_code,
    day: "",
    status: "",
    student_name: "",
    admission_no: "",
    term: "",
    academic_year: "",
  };
  // const { classes } = useSelector((state: RootState) => state.auth);
    const { user, sections, selected_branch, classes } = useSelector((state: RootState) => state.auth);
  const [form, setForm] = useState(initialForm);
  const routes = all_routes;
  // const sections =[];
  // const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState<Student[]>([]);
  // const [classis, setClassess] = useState<Classes[]>([]);
  const history = useNavigate();
  // const sections = [...new Set(classes.map((item) => item.section))];
  // Options for selects
  // const sectionsOptions: Option[] = sections?.map((section) => ({
  //   label: section,
  //   value: section,
  // }));

  // const classesOptions: Option[] = classis?.map((classItem) => ({
  //   label: classItem.class_name,
  //   value: classItem.class_name,
  // }));

  // const getCLasses = useCallback(() => {
  //   if (classes[0]?.teacher_id) {
  //     _get(
  //       `teacher_subjects?query_type=select&teacher_id=${classes[0]?.teacher_id}`,
  //       (res) => {
  //         if (res.data && res.data.length) {
  //           setClassess(res.data[0]);
  //           // setForm((prev) => ({
  //           //   ...prev,
  //           //   class_name: res.data[0][0].class_name,
  //           // }));
  //         }
  //       }
  //     );
  //   } else {
  //     setClassess([]);
  //   }
  // }, [classes[0]?.teacher_id]);

  // Fetch students based on selected class
  const getStudents = useCallback(() => {
    if (form.class_code) {
      _get(
        `students?query_type=select-class&current_class=${form.class_code}&school_id=${user?.school_id}&branch_id=${selected_branch?.branch_id}`,
        (res) => {
          // Initialize attendance and notes for each student
          if (res.data && res.data.length) {
            const fetchedStudents: Student[] = res.data.map((student: any) => ({
              ...student,
              attendance: "", // Default attendance
              notes: "",
            }));
            setStudents(fetchedStudents);
          }else {
          setStudents([]);
          }
        },
        (err) =>{
          setStudents([]);
          console.error(err)
        }
      );
    } else {
      setStudents([]);
    }
  }, [form.class_code, user,selected_branch]);

  // Fetch students when class_name changes
  useEffect(() => {
    getStudents();
    // getCLasses();
  }, [getStudents]);

  // Handle attendance change
  const handleAttendanceChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    studentId: string
  ) => {
    const { value } = event.target;
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student.admission_no === studentId
          ? { ...student, attendance: value as AttendanceStatus }
          : student
      )
    );
  };

  // Handle notes change
  const handleNotesChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    studentId: string
  ) => {
    const { value } = event.target;
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student.admission_no === studentId ? { ...student, notes: value } : student
      )
    );
  };
  const day = new Date().toISOString().split("T")[0];
  // console.log("ddda",day);

  // Handle form submission
  const handleSubmit = () => {
    const payload = students?.filter((student:Student)=>student.attendance!=="").map((student: Student) => ({
      admission_no: student.admission_no,
      id: student.id,
      student_name: student.student_name,
      status: student.attendance,
      class_name: form.class_name,
      academic_year: form.academic_year,
      term: form.term,
      section: form.section,
      teacher_name: form.teacher_name,
      teacher_id: form.teacher_id,
      notes: student.notes || "",
      query_type: "create",
      day: day,
      school_id: student.school_id,
    }));

    _post(
      "students/attendance",
      payload,
      (res) => {
        console.log("Submission successful", res);
        setStudents([]);
        setForm(initialForm);
        toast.success("Attendance submitted successfully!");
      },
      (err) => {
        console.error("Error submitting data", err);
        toast.error("There was an error submitting the data.");
      }
    );
  };

  // Define table columns with TypeScript types
  const columns = [
    {
      title: "Admission No",
      dataIndex: "admission_no",
      key: "admission_no",
      render: (text: string) => (
        <Link to="#" className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: Student, b: Student) =>
        a.admission_no.localeCompare(b.admission_no),
    },
    {
      title: "Student Name",
      dataIndex: "student_name",
      key: "student_name",
      render: (text: string) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{text}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: Student, b: Student) =>
        a.student_name.localeCompare(b.student_name),
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
      key: "attendance",
      render: (attendance: AttendanceStatus, record: Student) => (
        <div className="d-flex align-items-center check-radio-group flex-nowrap">
          {["Present", "Late", "Absent", "Holiday", "Halfday"].map((status) => (
            <label className="custom-radio me-2" key={status}>
              <input
                type="radio"
                name={`attendance-${record.admission_no}`}
                value={status}
                checked={attendance === status}
                onChange={(e) => handleAttendanceChange(e, record.admission_no)}
              />
              <span className="checkmark" />
              {status}
            </label>
          ))}
        </div>
      ),
      sorter: (a: Student, b: Student) =>
        a.attendance.localeCompare(b.attendance),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      render: (text: string, record: Student) => (
        <input
          type="text"
          className="form-control"
          placeholder="Enter Note"
          value={record.notes}
          onChange={(e) => handleNotesChange(e, record.admission_no)}
        />
      ),
      sorter: (a: Student, b: Student) =>
        (a.notes || "").localeCompare(b.notes || ""),
    },
  ];

  // useEffect(() => {
  //   if (form.section) {
  //     _get(
  //       `classes?query_type=select-section-classes&section=${form.section}&school_id=${user.school_id}`,
  //       (res) => {
  //         if (res.success && res.data && res.data.length) {
  //           setClasses(res.data);
  //         }
  //       },
  //       (err) => {
  //         console.log(err);
  //       }
  //     );
  //   }
  // }, [form, user.id]);

  const classOptions = 
    classes?.length > 0
      ? classes?.map((item: any) => ({
          label: item.class_name,
          value: item.class_code,
        }))
      : [];

  const mapped_section = sections?.map((i: any) => ({
    label: i.section_name,
    value: i.section_name,
  }));
  const handleClassChange = (value: any, label: any) => {
    setForm((p) => ({ ...p, class_name: value, class_code: label, school_id: user.school_id, teacher_id: user.id, teacher_name: user.name, academic_year: user.academic_year, term: user.term }));
  };
  return (
    <div className="page-wrapper">
     
        {/* /Page Header */}

        {/* Student List */}
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
          <div className="mb-3">
                <Button onClick={()=>history(routes.classAttendance)}> <i className="ti ti-arrow-back" /> Back</Button>
              </div>
             
              <h4 className="mb-3">Daily Attendance</h4>
               <div className="mb-3">
                <label className="form-label">Class</label>
                <CommonSelect
                  options={classOptions}
                  defaultValue={{
                    label: form.class_name,
                    value: form.class_code
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    handleClassChange(newValue?.label, newValue?.value)
                  }
                />
              </div>
            </div> 
          {/* {JSON.stringify(students)} */}
          {/* Table Body */}
          <div className="card-body p-0 py-3">
            <Table
              dataSource={students}
              columns={columns}
              pagination={false}
              rowKey="admission_no"
              
            />
          </div>

          {/* Submission Button */}
          <div className="card-footer d-flex justify-content-end">
            {students.filter((student:Student)=>student.attendance!=="").length?<button
              className="btn btn-success"
              onClick={handleSubmit}
              disabled={students.length === 0}
            >
              Submit Attendance
            </button>:null}
          </div>
        </div>
        {/* /Student List */}
      </div>
  );
};

export default ClassAttendanceForm;
